import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import { Trans } from 'react-i18next';
import Stack from "@mui/material/Stack";
import { Link } from "@mui/material";

type Props = {
  unitTypes: any[],
  invertSelected: any
}

export default (props: Props) =>
  <Box sx={{margin: '0px 13%'}}>
    <Stack direction="row" spacing={2} justifyContent="space-between" mb={3}>
      <Box className='units-catalog-title' >Catálogo de vehículos</Box>
      <Box className='units-catalog-title' ><Link href="https://olca.com.ar/catalogo/" target="_blank" rel="noreferrer"
                                                  className="primary" color="primary">Sitio web OLCA</Link></Box>
    </Stack>
    {props.unitTypes.map((it, index) =>
       <Chip key={index}
        label={<Trans i18nKey={`models.carClassifications.labels.${it.unitType}`}></Trans>}
        variant={it.selected ? 'filled' : 'outlined'}
        size="small"
        className={it.unitType =='NOVELTY'? 'catalog-chip-novelty' :'catalog-chip' }
        onClick={() => props.invertSelected(index)}
      />
    )}
  </Box>
